import { format } from "date-fns";
import { isAlphabetOnly, isEmailValid, isZeroOrPositiveNumber, numberStartWith6789Validator } from "../utils/validator";

const dateFormate = "yyyy-MM-dd";
const minDate = format(new Date(), dateFormate);

export const Inventory_Data = [
  {
    colmd: "12",
    key: "inventorydate",
    label: "Date",
    type: "date",
    id: "inventorydate",
    defaultValue: "",
    min: minDate,
    "disabled": true,
    format: "dd/MM/yyyy",
    validators: [{
      name: "required",
      value: true,
      validationMessage: "Date is required.",
    }
    ],
  },

  {
    colmd: "12",
    "key": "account",
    "label": "Account",
    "type": "select",
    id: "account",
    "options": [],
    "disabled": false,
    "validators": [{ "name": "required", "value": true, "validationMessage": "Account is required." }]
  },
  {
    colmd: "12",
    "key": "location",
    "label": "Location",
    "type": "select",
    id: "location",
    "disabled": false,
    "options": [],
    "validators": [{ "name": "required", "value": true, "validationMessage": "Location is required." }]
  },
  {
    colmd: "12",
    "key": "storageArea",
    "label": "Storage Area",
    "type": "select",
    id: "storageArea",
    "disabled": false,
    "options": [],
    "validators": [{ "name": "required", "value": true, "validationMessage": "Storage Area is required." }]
  },
  {
    colmd: "12",
    key: "inventoryduedate",
    label: "Inventory Due Date",
    type: "date",
    id: "inventoryduedate",
    defaultValue: "",
    "disabled": true,
    format: "dd/MM/yyyy",
    validators: [{
      name: "required",
      value: true,
      validationMessage: "Inventory Due Date is required.",
    }
    ],
  },
  {
    colmd: "12",
    key: "inventorycounted",
    type: "text",
    id: "inventorycounted",
    "disabled": true,
    label: "Inventory Counted By",
    validators: [
      {
        name: "required",
        value: true,
        validationMessage: "Inventory Counted is required.",
      },
      {
        name: "minLength",
        value: 3,
        validationMessage: "Please enter at least 3 letters",
      },
      {
        name: "maxLength",
        value: 30,
        validationMessage: "Please enter no more than 30 characters.",
      },
    ],
  },

];
export const INMATE_ACCOUNT_FORM = [

  {
    colmd: '12',
    key: 'account',
    label: "Account",
    type: 'select',
    "options": [{ key: -1, label: "Select", value: -1 }],
    id: 'account',
    validators: [{ "name": "required", "value": true, "validationMessage": "Account is required." }]
  },
  {
    colmd: '12',
    label: "Location",
    key: 'location',
    type: 'select',
    "options": [{ key: -1, label: "Select", value: -1 }],
    id: 'location',
    validators: [{ "name": "required", "value": true, "validationMessage": "Location is required." }]
  },
  {
    colmd: '12',
    label: "Meal Period",
    key: 'meal',
    type: 'select',
    id: 'meal',
    "options": [{ key: -1, label: "Select", value: -1 }],
    validators: [{ "name": "required", "value": true, "validationMessage": "Meal period is required." }]
  },
  {
    colmd: "12",
    key: "mealDate",
    label: "Current Date",
    type: "date",
    id: "mealDate",
    defaultValue: "",
    min: minDate,
    "disabled": true,
    format: "dd/MM/yyyy",
    validators: [{
      name: "required",
      value: true,
      validationMessage: "Date is required.",
    }
    ],
  },
]
export const Account_Inventory_Data = [
  {
    colmd: "12",
    key: "inventorydate",
    label: "Date",
    type: "date",
    id: "inventorydate",
    defaultValue: "",
    min: minDate,
    "disabled": true,
    format: "dd/MM/yyyy",
    validators: [{
      name: "required",
      value: true,
      validationMessage: "Date is required.",
    }
    ],
  },

  {
    colmd: "12",
    "key": "accountId",
    "label": "Account",
    "type": "select",
    id: "accountId",
    "options": [],
    "disabled": false,
    "validators": [{ "name": "required", "value": true, "validationMessage": "Account is required." }]
  },
  {
    colmd: "12",
    "key": "storageArea",
    "label": "Storage Area",
    "type": "select",
    id: "storageArea",
    "disabled": false,
    "options": [],
    "validators": [{ "name": "required", "value": true, "validationMessage": "Storage Area is required." }]
  },
  {
    colmd: "12",
    key: "inventoryduedate",
    label: "Inventory Due Date",
    type: "date",
    id: "inventoryduedate",
    defaultValue: "",
    "disabled": true,
    format: "dd/MM/yyyy",
    validators: [{
      name: "required",
      value: true,
      validationMessage: "Inventory Due Date is required.",
    }
    ],
  },
  {
    colmd: "12",
    key: "inventorycounted",
    type: "text",
    id: "inventorycounted",
    "disabled": true,
    label: "Inventory Counted By",
    validators: [
      {
        name: "required",
        value: true,
        validationMessage: "Inventory Counted is required.",
      },
      {
        name: "minLength",
        value: 3,
        validationMessage: "Please enter at least 3 letters",
      },
      {
        name: "maxLength",
        value: 30,
        validationMessage: "Please enter no more than 30 characters.",
      },
    ],
  },

];
export const PRODUCT_FORM = [
  {
    colmd: "12",
    key: "button",
    type: "button",
    id: 0,
    value: "Camera Scan",
    class: "btn",
    hide: false,
  },

  {
    colmd: "12",
    key: "barcodenumber",
    isRegexpRequired: true,
    type: "text",
    id: "barcodenumber",

    label: "Scan OR Enter Barcode",
    validators: [
      {
        name: "required",
        value: true,
        validationMessage: "Barcode Number is required",
      },
    ],
  },

  {
    colmd: "12",
    key: "productCode",
    type: "text",
    id: "productCode",
    disabled: true,
    label: "Product Code",
  },
  {
    colmd: "12",
    key: "productname",
    type: "text",
    id: "productname",
    disabled: true,
    label: "Product Name",

  },

  {
    colmd: "12",
    key: "inventoryunit",
    type: "text",
    id: "inventoryunit",
    disabled: true,
    label: "Inventory Unit",
  },
  {
    colmd: "12",
    key: "previousquantity",
    type: "number",
    id: "previousquantity",
    disabled: true,
    label: "Quantity Counted This Inventory",
  },


  {
    colmd: "12",
    key: "unitprice",
    type: "text",
    id: "unitprice",
    disabled: true,
    label: "Unit Price",
  },
  {
    colmd: "12",
    key: "updatenewquaninty",
    type: "number",
    id: "updatenewquaninty",
    disabled: false,
    label: "Update New Quantity",
    "steps": "0.01",
    "props": { "min": 0 },
  },
  {
    colmd: "12",
    key: "Remarks",
    type: "text",
    id: "Remarks",
    disabled: false,
    label: "Note/Comments",
    validators: [

    ],
  },
];
export const ACCOUNT_PRODUCT_FORM = [
  {
    colmd: "12",
    key: "button",
    type: "button",
    id: 0,
    value: "Camera Scan",
    class: "btn",
    hide: false,
  },

  {
    colmd: "12",
    key: "barcodenumber",
    type: "text",
    id: "barcodenumber",
    isRegexpRequired: true,
    label: "Scan OR Enter Barcode",
    validators: [
      {
        name: "required",
        value: true,
        validationMessage: "Barcode Number is required",
      },
    ],
  },

  {
    colmd: "12",
    key: "productCode",
    type: "text",
    id: "productCode",
    disabled: true,
    label: "Product Code",
  },
  {
    colmd: "12",
    key: "productname",
    type: "text",
    id: "productname",
    disabled: true,
    label: "Product Name",
  },

  {
    colmd: "12",
    key: "inventoryunit",
    type: "text",
    id: "inventoryunit",
    disabled: true,
    label: "Inventory Unit",
  },
  {
    colmd: "12",
    key: "previousquantity",
    type: "number",
    id: "previousquantity",
    disabled: true,
    label: "Quantity Counted This Inventory",
  },


  {
    colmd: "12",
    key: "unitprice",
    type: "text",
    id: "unitprice",
    disabled: true,
    label: "Unit Price",
  },
  {
    colmd: "12",
    key: "updatenewquaninty",
    type: "number",
    id: "updatenewquaninty",
    disabled: false,
    label: "Update New Quantity",
    "props": { "min": 0 },
    "steps": "0.01"
  },

];
export const FILTER_FORM = [
  {
    colmd: "12",
    "key": "account",
    "label": "Account",
    "type": "select",
    id: "account",
    "options": [],
    "disabled": false,
    "validators": [{ "name": "required", "value": true, "validationMessage": "Account is required." }]
  },
  {
    colmd: "12",
    "key": "location",
    "label": "Location",
    "type": "select",
    id: "location",
    "disabled": false,
    "options": [],
    "validators": [{ "name": "required", "value": true, "validationMessage": "Location is required." }]
  },
  {
    colmd: "12",
    "key": "storageArea",
    "label": "Storage Area",
    "type": "select",
    id: "storageArea",
    "disabled": false,
    "options": [],
    "validators": [{ "name": "required", "value": true, "validationMessage": "Storage Area is required." }]
  },
];
export const FILTER_FORM_STORAGE = [
  {
    colmd: "12",
    "key": "account",
    "label": "Account",
    "type": "select",
    id: "account",
    "options": [],
    "disabled": false,
    "validators": [{ "name": "required", "value": true, "validationMessage": "Account is required." }]
  },
  {
    colmd: "12",
    "key": "location",
    "label": "Location",
    "type": "select",
    id: "location",
    "disabled": false,
    "options": [],
    "validators": [{ "name": "required", "value": true, "validationMessage": "Location is required." }]
  },
];
export const customValidators = [
  {
    key: 'firstname',
    validator: isAlphabetOnly,
    message: 'Please enter alphabets only.'
  },
  {
    key: "updatenewquaninty",
    validator: isZeroOrPositiveNumber, // function to be called
    message: "Number should be greater than 0", // message to show
  },
  {
    key: 'lastname',
    validator: isAlphabetOnly,
    message: 'Please enter alphabets only.'
  },
  {
    key: 'Email',
    validator: isEmailValid,
    message: 'invalid email id with missing domain name, @, .com, gmail id etc.'
  },
  {
    key: 'mobileno',
    validator: numberStartWith6789Validator,
    message: '10 digit phone number starting with 6,7,8,9 only.'
  },
]


export const FILTER_FORM_ACCOUNT_WISE = [
  {
    colmd: "12",
    "key": "account",
    "label": "Account",
    "type": "select",
    id: "account",
    "options": [],
    "disabled": false,
    "validators": [{ "name": "required", "value": true, "validationMessage": "Account is required." }]
  }
];